export default __webpack_public_path__ + "static/media/kitchen3-after1-2048w.7e6f99b5.webp";